/**
 * Custom element for VAT price display block.
 * Listens for variant:update and swaps content from section re-fetch HTML.
 */
if (!customElements.get('vat-price-display')) {
  class VatPriceDisplay extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.shopify-section') || this.closest('dialog');
      if (!this.scope) return;
      this._onVariantUpdate = this._onVariantUpdate.bind(this);
      this.scope.addEventListener('variant:update', this._onVariantUpdate);
    }

    disconnectedCallback() {
      if (this.scope) {
        this.scope.removeEventListener('variant:update', this._onVariantUpdate);
      }
    }

    /** @param {CustomEvent & { detail: { data?: { html?: Document; newProduct?: { id: string }; productId?: string } } }} event */
    _onVariantUpdate(event) {
      const data = event.detail?.data;
      const html = data?.html;
      if (!html) return;

      if (data.newProduct) {
        this.dataset.productId = data.newProduct.id;
      } else if (data.productId && String(data.productId) !== this.dataset.productId) {
        return;
      }

      const updated = html.querySelector(`vat-price-display[data-block-id="${this.dataset.blockId}"]`);
      if (!updated) return;

      const newContainer = updated.querySelector('[ref="vatContainer"]');
      const currentContainer = this.querySelector('[ref="vatContainer"]');
      if (newContainer && currentContainer) {
        currentContainer.replaceWith(newContainer.cloneNode(true));
      }
    }
  }

  customElements.define('vat-price-display', VatPriceDisplay);
}
